import { render, staticRenderFns } from "./BonusHandle.vue?vue&type=template&id=34ddf81b&scoped=true"
import script from "./BonusHandle.vue?vue&type=script&lang=js"
export * from "./BonusHandle.vue?vue&type=script&lang=js"
import style0 from "./BonusHandle.vue?vue&type=style&index=0&id=34ddf81b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34ddf81b",
  null
  
)

export default component.exports